import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { AppRole } from './core/models/api/departments';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/components/login/login.component')
      .then(m => m.LoginComponent),
    data: {
      title: 'Login',
      description: 'Sign in to your account'
    }
  },
  {
    path: 'access-denied',
    loadComponent: () => import('./features/auth/access-denied/access-denied.component')
      .then(m => m.AccessDeniedComponent),
    data: {
      title: 'Access denied',
      description: 'You do not have access to this application'
    }
  },
  {
    path: '',
    redirectTo: '/timeline',
    pathMatch: 'full'
  },
  {
    path: 'timeline',
    loadComponent: () => import('./features/resource-assignments/components/assignment-calendar/assignment-calendar.component')
      .then(m => m.AssignmentTimelineComponent),
    canActivate: [authGuard],
    data: {
      title: 'Timeline',
      description: 'Visual timeline of resource assignments'
    }
  },
  {
    path: 'resources',
    loadChildren: () => import('./features/resources/resources.module').then(m => m.ResourcesModule),
    canActivate: [authGuard],
    data: { 
      title: 'Resources',
      description: 'Manage people and their working schedules'
    }
  },
  {
    path: 'customers',
    loadChildren: () => import('./features/customers/customers.module').then(m => m.CustomersModule),
    canActivate: [authGuard],
    data: { 
      title: 'Customers',
      description: 'Manage customers and their projects'
    }
  },
  {
    path: 'roles',
    loadChildren: () => import('./features/roles/roles.module').then(m => m.RolesModule),
    canActivate: [authGuard],
    data: { 
      title: 'Roles',
      description: 'Manage organizational roles'
    }
  },
  // Future feature routes will be added as modules are created
  {
    path: 'projects',
    loadChildren: () => import('./features/projects/projects.module').then(m => m.ProjectsModule),
    canActivate: [authGuard],
    data: { 
      title: 'Projects',
      description: 'Manage projects and deliverables'
    }
  },
  {
    path: 'resource-assignments',
    loadChildren: () => import('./features/resource-assignments/resource-assignments.module').then(m => m.ResourceAssignmentsModule),
    canActivate: [authGuard],
    data: { 
      title: 'Resource Assignments',
      description: 'Assign resources to projects'
    }
  },
  {
    path: 'admin/departments',
    loadComponent: () => import('./features/admin/departments/department-management.component')
      .then(m => m.DepartmentManagementComponent),
    canActivate: [authGuard, roleGuard],
    data: {
      title: 'Department management',
      requiredRole: AppRole.OrganizationAdministrator,
    },
  },
  {
    path: 'admin/access-control',
    loadComponent: () => import('./features/admin/access-control/access-control-management.component')
      .then(m => m.AccessControlManagementComponent),
    canActivate: [authGuard, roleGuard],
    data: {
      title: 'Access control',
      requiredRole: AppRole.OrganizationAdministrator,
    },
  },
  {
    path: 'bootstrap',
    loadComponent: () => import('./features/auth/bootstrap/bootstrap.component')
      .then(m => m.BootstrapComponent),
    canActivate: [authGuard],
    data: {
      title: 'Instellen',
    },
  },
  {
    path: '**',
    redirectTo: '/timeline'
  }
];
